import { Box, Loader, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function ExtractionLoadingPanel() {
  return (
    <Box p="xl" style={{ borderRadius: 16 }} bg="gray.0" w="100%">
      <Stack gap="lg" align="center" py="lg">
        <ThemeIcon variant="light" size={72} radius="xl" color="blue">
          <IconSparkles size={36} />
        </ThemeIcon>
        <Text fw={FONT_WEIGHTS.semibold} size="textXl">
          Auto-branding in progress
        </Text>
        <Text c="gray.7" size="textSm" ta="center" maw={360}>
          We&apos;re analysing the document with a vision model to pull out every brand element we
          can find.
        </Text>
        <Loader size="md" />
      </Stack>
    </Box>
  );
}
